import React, { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import { ConfigProvider } from "antd";
import RouteList from "./RouteList";

import "../assets/scss/app.scss";
import currentLocation from "../providers/currentLocation";

const queryClient = new QueryClient();

export default function Routers() {
	useEffect(() => {
		const checkForUpdates = async () => {
			const fetchVersion = await fetch("/meta.json?cache=" + Date.now()); // bust cache
			const { version } = await fetchVersion.json();

			console.log("new meta version: ", version);

			const storedVersion = localStorage.getItem("appVersion");

			if (version !== storedVersion) {
				console.log("New version found. Clearing cache...");

				const cacheNames = await caches.keys();
				await Promise.all(
					cacheNames.map(async (name) => {
						try {
							await caches.delete(name);
							console.log("Cache deleted:", name);
						} catch (e) {
							console.warn("Failed to delete cache:", name, e);
						}
					})
				);

				localStorage.setItem("appVersion", version);
				window.location.reload(true);
			}
		};

		checkForUpdates();

		// window.location.href = "https://joyalife.com.au/maintenance-page";

		const interval = setInterval(checkForUpdates, 60000); // check every 1 min
		return () => clearInterval(interval);
	}, []);

	useEffect(() => {
		const fetchLocation = async () => {
			try {
				let localStorageCurrentLocations = localStorage.getItem(
					"currentLocations"
				)
					? JSON.parse(localStorage.getItem("currentLocations"))
					: null;

				// Check if the location is already stored and has the necessary properties
				if (
					!localStorageCurrentLocations ||
					!localStorageCurrentLocations.coords
				) {
					const currentLocations = await currentLocation(); // Ensure this function is defined and returns a promise

					// Check if the fetched location has the necessary coordinates
					if (
						currentLocations &&
						currentLocations.coords &&
						currentLocations.coords.latitude &&
						currentLocations.coords.longitude
					) {
						localStorage.setItem(
							"currentLocations",
							JSON.stringify(currentLocations)
						);
					}
				}
			} catch (error) {
				console.error("Failed to fetch or store location:", error);
			}
		};

		fetchLocation();
	}, []);

	return (
		<ConfigProvider theme={{ hashed: false }}>
			<QueryClientProvider client={queryClient}>
				<Router
					future={{
						v7_relativeSplatPath: true,
						v7_startTransition: true,
					}}
				>
					<RouteList />
				</Router>
			</QueryClientProvider>
		</ConfigProvider>
	);
}
